import { Tag } from "antd";
import React, { Fragment, useState } from "react";
import { Container, Header, Item, Segment } from "semantic-ui-react";
import AboutGrid from "../components/AboutGrid";
import CustomDrawer from "../components/DrawerCustom";
import ImageWrapper from "../components/ImageWrapper";
import QueryAnswers from "../components/QueryAnswers";
import TheGoldenQueries from "../components/TheGoldenQueries";

/**
 * @author
 * @function About
 **/

const About = ({setValue,value}) => {
  
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);
  const [normal, setNormal] = useState(false);
  // const SwitchEducation = name => {
  //   switch (name) {
  //     case "School":
  //       return "School";
  //     default:
  //       return "";
  //   }
  // };

  const HandleClick = value => {
    setName(value);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setName("");
  };

  let languagesArray = [
    "C",
    "C++",
    "C#",
    "Java",
    "Python",
    "Ruby",
    "Javascript"
  ];
  let Others = [
    "Swagger",
    "Git",
    "Microsoft Office",
    "Coggle",
    "Web Designing",
    "Adobe",
    "Unity 3D"
  ];
  let Frameworks = [
    "ReactJs",
    "Angular",
    "Vue",
    "React-Native",
    "Ruby On Rails",
    "ExpressJs",
    "Django",
    "Flask"
  ];
  let arrayParent = ["Languages", "Frameworks", "Others"];

  let ViewNormal = [].concat(languagesArray, Frameworks, Others);

  const NormalView = () => {
    return (
      <>
        <div
          style={{
            justifyContent: "space-between"
          }}
        >
          {ViewNormal.map(lang => (
            <Tag style={{ marginTop: "4px" }} color="magenta">
              {lang}
            </Tag>
          ))}
        </div>
      </>
    );
  };
  const mapParentToChild = value => {
    switch (value) {
      case "Languages":
        return languagesArray.map(lang => <Tag color="magenta">{lang}</Tag>);

      case "Frameworks":
        return Frameworks.map(lang => <Tag color="magenta">{lang}</Tag>);

      case "Others":
        return Others.map(lang => <Tag color="magenta">{lang}</Tag>);
      default:
        return "";
    }
  };

  const School = (
    <>
      <span>
        <Tag color="magenta">Name</Tag> : Mesco Grades High School
      </span>
      <br />
      <br />
      <span>
        <Tag color="magenta">CGPA</Tag> : 8.0
      </span>
      <br />
      <br />
      <span>
        <Tag color="magenta">Duration</Tag> : 2002 - 2015
      </span>
    </>
  );
  const twelth = (
    <>
      <span>
        <Tag color="magenta">Name</Tag> : Sri Chaitaniya Junior kalasala
      </span>
      <br />
      <br />
      <span>
        <Tag color="magenta">CGPA</Tag> : 7.4
      </span>
      <br />
      <br />
      <span>
        <Tag color="magenta">Duration</Tag> : 2015 - 2017
      </span>
    </>
  );
  const College = (
    <>
      <span>
        <Tag color="magenta">Name</Tag> : Joginpally br engineering college
      </span>
      <br />
      <br />
      <span>
        <Tag color="magenta">CGPA</Tag> : 6.9 (upto 6 semesters)
      </span>
      <br />
      <br />
      <span>
        <Tag color="magenta">Duration</Tag> : 2017 - 2021 (expected)
      </span>
    </>
  );
  const Work = (
    <>
      <span>
        <Tag style={marginForTags} color="magenta">
          Name
        </Tag>{" "}
        : Possibilities Hunters Labs (PoHu)
      </span>
      <br />
      <span>
        <Tag style={marginForTags} color="magenta">
          Position
        </Tag>{" "}
        : Front End Developer Intern
      </span>
      <br />
      <span>
        <Tag style={marginForTags} color="magenta">
          Duration
        </Tag>{" "}
        : 2020 - current
      </span>
      <br />
      <hr />
      <p style={{ textAlign: "center" }}>
        <Tag style={{ textAlign: "center" }} color="magenta">
          Role/Responsibilities
        </Tag>
      </p>
      <Segment>
        <p>
          ● Developing and implementing front-end architecture to support user
          interface concepts.{" "}
        </p>
        <p>● Monitoring and improving front-end performance. </p>
        <p>● Documenting application changes and developing updates. </p>
        <p>
          ● Troubleshooting interface software and debugging application codes.
        </p>
      </Segment>
    </>
  );

  const displayEducation = value => {
    switch (value) {
      case "School":
        return School;
      case "12th":
        return twelth;
      case "College":
        return College;
      case "Work":
        return Work;
      default:
        return "";
    }
  };
  const onQueryClicked = (item) => {
      setValue(item)
  }

  const aboutMe = (
    <>
      <Container style={{ justifyContent: "space-between",boxShadow: "0px 3px 28px rgba(0, 0, 0, 0.04)", }}>
        <ImageWrapper />
        <Header textAlign="center" as="h5">
          I'm a front-end developer from
          <span style={{ color: "orange" }}>In</span>
          <span style={{ color: "green" }}>dia</span> who creates digital
          experiences that everyone likes to use.
        </Header>
        {/* <Segment>
    Hello
  </Segment> */}
        {/* <Segment style = {{marginBottom : "20px"}}> */}
        <Header
          color="olive"
          textAlign="center"
          style={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          SKILLS{" "}
          <span
            onClick={() => setNormal(!normal)}
            style={{
              fontSize: "7px",
              color: "#000000",
              float: "right",
              textDecoration: "underline"
            }}
          >
            {!normal ? "show normal" : "show awesome"}
          </span>
        </Header>
        {!normal
          ? arrayParent.map(parent => {
              return (
                <>
                  <div
                    className="inner mt-4"
                    style={{
                      overflowY: "hidden",
                      overflowX: "hidden",
                      marginTop: "4px"
                    }}
                  >
                    <div className="marquee">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between"
                        }}
                      >
                        <Tag color="success">{parent} : </Tag>

                        {mapParentToChild(parent)}
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          : NormalView()}

        {/* </Segment> */}
        <Item style={{ display: name ? "none" : "", marginTop: "25px" }}>
          <AboutGrid getClickedValue={HandleClick} />
        </Item>
        <br />
        <br />
        <TheGoldenQueries onQueryButtonClicked ={onQueryClicked}/>
      </Container>
      <CustomDrawer title={name} open={open} onClose={handleClose}>
        {displayEducation(name)}
      </CustomDrawer>
    </>
  );

  const renderAbout = () => {
    switch (value) {
      case "about":
        return aboutMe;
      case "query":
        return <QueryAnswers/>
      default:
        return aboutMe
    }
  };

  return <Fragment>{renderAbout()}</Fragment>;
};

export default About;

const marginForTags = {
  marginBottom: "7px"
};
